import { render, staticRenderFns } from "./TariffCreate.vue?vue&type=template&id=721cd8b9"
import script from "./TariffCreate.vue?vue&type=script&lang=ts"
export * from "./TariffCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports